import React, { useState } from 'react';
import BackfillHistoryModal from './overview/BackfillHistoryModal';

type Props = {
    canEdit?: boolean;
    onRunBackfillHistory?: (x: {
        targetEvToPvRatio: number;
        pattern: 'UNIFORM' | 'FRONT_DELAY' | 'MID_DIP';
    }) => Promise<void>;
    onResetBackfillHistory?: () => Promise<void>;
};

export default function WbsOpsToolbar({ canEdit = false, onRunBackfillHistory, onResetBackfillHistory }: Props) {
    const [backfillOpen, setBackfillOpen] = useState(false);

    const showToolbar = !!onRunBackfillHistory || !!onResetBackfillHistory;
    if (!showToolbar) return null;

    return (
        <>
            <div className="mb-3 flex items-center gap-2 rounded-xl border bg-white px-3 py-2">
                <div className="text-xs font-medium text-gray-500">Operations</div>

                {onRunBackfillHistory && (
                    <button
                        type="button"
                        className="rounded-md border bg-white px-3 py-1.5 text-xs text-gray-800 hover:bg-gray-50 disabled:opacity-50"
                        onClick={() => setBackfillOpen(true)}
                        disabled={!canEdit}
                        title={!canEdit ? '권한이 없습니다.' : '과거 EV 이력 자동 생성'}
                    >
                        Backfill
                    </button>
                )}

                {onResetBackfillHistory && (
                    <button
                        type="button"
                        className="rounded-md border border-rose-300 bg-white px-3 py-1.5 text-xs text-rose-600 hover:bg-rose-50 disabled:opacity-50"
                        onClick={onResetBackfillHistory}
                        disabled={!canEdit}
                        title={!canEdit ? '권한이 없습니다.' : 'AUTO_BACKFILL 데이터 삭제'}
                    >
                        Reset Backfill
                    </button>
                )}
            </div>

            {onRunBackfillHistory && (
                <BackfillHistoryModal
                    open={backfillOpen}
                    onClose={() => setBackfillOpen(false)}
                    onRun={onRunBackfillHistory}
                />
            )}
        </>
    );
}
